export default class HttpOperationError extends Error {
    public handled = false;

    constructor(message: string, public details?: string | Error) {
        super(message);
    }
}
